import React from 'react';
import styles from './SearchArticlesList.module.css';
import ArticleListItem from 'shared/components/ArticleListItem/ArticleListItem';
import { Api } from 'api/znaniya-server';

type Props = {
  articles: Api.GetArticleBySearch200Response.Article[];
  filterByDiscipline: string | null;
};

const SearchArticlesList = ({ articles, filterByDiscipline }: Props) => {
  if (filterByDiscipline && filterByDiscipline !== 'all') {
    return (
      <div className={styles.wrapper}>
        {articles
          .filter((e) => {
            return e.discipline_kind === filterByDiscipline;
          })
          .map((e) => (
            <ArticleListItem article={e} key={e.id} discipline_kind={e.discipline_kind} />
          ))}
      </div>
    );
  } else {
    return (
      <div className={styles.wrapper}>
        {articles.map((e) => (
          <ArticleListItem article={e} key={e.id} discipline_kind={e.discipline_kind} />
        ))}
      </div>
    );
  }
};

export default SearchArticlesList;
